import { render, staticRenderFns } from "./low-diagram.vue?vue&type=template&id=4b3f965a&scoped=true&"
import script from "./low-diagram.vue?vue&type=script&lang=js&"
export * from "./low-diagram.vue?vue&type=script&lang=js&"
import style0 from "./low-diagram.vue?vue&type=style&index=0&id=4b3f965a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3f965a",
  null
  
)

export default component.exports